import de from '@translations/de/markersPopup.json';
import en from '@translations/en/markersPopup.json';
import pl from '@translations/pl/markersPopup.json';
import sl from '@translations/sl/markersPopup.json';
import uk from '@translations/uk/markersPopup.json';
import bg from '@translations/bg/markersPopup.json';
import cz from '@translations/cz/markersPopup.json';
import fr from '@translations/fr/markersPopup.json';
import gr from '@translations/gr/markersPopup.json';
import it from '@translations/it/markersPopup.json';
import pr from '@translations/pr/markersPopup.json';
import ru from '@translations/ru/markersPopup.json';
import sk from '@translations/sk/markersPopup.json';
import sp from '@translations/sp/markersPopup.json';
import tr from '@translations/tr/markersPopup.json';
import hu from '@translations/hu/markersPopup.json';
import { ITranslations } from '@/types/common';
import { MarkersPopupTransFields } from './types';

export const markersPopupTranslations: ITranslations<MarkersPopupTransFields> = {
  name: 'markersPopup',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
